import React, { useState, useEffect } from 'react';
import { IconButton, TextField, Modal, Typography, Box, Autocomplete, FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import '../organizationStaff/organizationStaff.css'
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import '../organizationStaff/organizationStaff.css'
import axios from 'axios';
import Swal from 'sweetalert2';
import { useLocation } from 'react-router-dom';

const therapeuticAreasArr = [
    { title: 'Cardiology' },
    { title: 'Oncology' },
    { title: 'Neurology' },
    { title: 'Dermatology' },
    { title: 'Endocrinology' },
    { title: 'Gastroenterology' },
    { title: 'Hematology' },
    { title: 'Immunology' },
    { title: 'Infectious Diseases' },
    { title: 'Nephrology' },
    { title: 'Ophthalmology' },
    { title: 'Orthopedics' },
    { title: 'Pulmonology' },
    { title: 'Rheumatology' },
    { title: 'Urology' },
    { title: 'Psychiatry' },
    { title: 'Pediatrics' },
    { title: 'Obstetrics and Gynecology' },
    { title: 'Otorhinolaryngology' },
    { title: 'Radiology' },
    { title: 'Allergy and Immunology' },
    { title: 'Clinical Pharmacology' },
    { title: 'Medical Genetics' },
    { title: 'Neonatology' },
    { title: 'Nutrition' },
    { title: 'Oncology Surgery' },
    { title: 'Physical Medicine and Rehabilitation' },
    { title: 'Podiatry' },
    { title: 'Sleep Medicine' },
    // Add more therapeutic areas as needed
];

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: '#169a8f',
        color: theme.palette.common.white,
        textAlign: 'center',
        fontWeight:800,
        fontSize: 16,
        fontFamily:'nunito'
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 18,
         color: '#178383',
        textAlign: 'center',
        fontWeight:600,
        fontFamily:'nunito'
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));

const useQuery = () => {
    return new URLSearchParams(useLocation().search);
}
const   StaffStudy = () => {
    const [allStudies, setAllStudies] = useState([])

    let query = useQuery();
    let paramValue = query.get("staffId");
    // Bearer Token
    const token = localStorage.getItem('token');
    const tokenValue = token ? token.slice(1, token.length - 1) : ""

    // User Object
    const user = JSON.parse(localStorage.getItem('user'));

    const getData = () => {
        const url = `https://research-mate-b35a10757d5a.herokuapp.com/api/staff/oneStaff?staffId=${paramValue}`;
        axios.get(url, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${tokenValue}`
            }
        })
            .then(res => {
                const studies = res.data.staff.studies
                if (studies) {
                    setAllStudies(studies)
                }
            })
            .catch(error => {
                console.log("error--->", error.response.data.message)
                Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: error.response.data.error,
                });
            })
    }

    useEffect(() => {
        getData()
    }, [])

    const [open, setOpen] = useState(false);

    const handleOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        reset()
    };
    const [enrollment, setEnrollment] = useState('');
    const [error, setError] = useState(false);

    const handleInputChange = (event) => {
        const { value } = event.target;
        if (value === '' || /^\d+%?$/.test(value)) {
            setEnrollment(value);
            setError(false);
        } else {
            setError(true);
        }
    };

    const handleInputBlur = () => {
        if (!enrollment.endsWith('%')) {
            setError(true);
        }
    };

    const handleInputFocus = () => {
        setError(false);
    };

    const [phase, setPhase] = useState('');
    const [therapeuticAreas, setTherapeuticAreas] = useState('');
    const [indication, setIndication] = useState('');
    const [enrollementGoal, setEnrollementGoal] = useState('');
    const [enrollementMet, setEnrollementMet] = useState('');

    const reset = () => {
        setPhase(null)
        setTherapeuticAreas(null)
        setIndication(null)
        setEnrollementGoal(null)
        setEnrollementMet(null)
        setEnrollment(null)
    }

    const handleSubmit = async () => {
        // Staff information
        const study = {
            phase,
            therapeuticAreas,
            indication,
            enrollementGoal,
            enrollementMet,
        };
        console.log(study)
        // URL for saving study information
        const saveUrl = `https://research-mate-b35a10757d5a.herokuapp.com/api/staff/staffStudy?staffId=${paramValue}`;

        // Make the API request to save study information
        axios.post(saveUrl, study, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${tokenValue}`
            }
        })
            .then(res => {
                console.log("Save Response:", res.data);
                Swal.fire({
                    title: "Added!",
                    text: "Your study exp has been added",
                    icon: "success",
                    customClass: {
                        container: 'swal2-container-custom'
                    }
                });
                getData()
                //Close Modal
                handleClose();
            })
            .catch(error => {
                console.log("Error:", error);
                Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: error.response?.data?.message || error.message,
                });
            })


    };

    return (
        <Box sx={{ p: 2, color: '#169a8f', fontWeight: 'bold' }}>
            <IconButton variant="outlined" onClick={handleOpen} sx={{ bgcolor: '#169a8f', '& .MuiSvgIcon-root': { fontSize: '2.5rem' } }}>
                <AddIcon />
            </IconButton>

            <Modal open={open} onClose={handleClose}>
                <Box
                    sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: 1000,
                        bgcolor: 'background.paper',
                        boxShadow: 24,
                        p: 4,
                    }}
                >
                               <h4  style={{color:'rgb(23 131 131)'}}> Add Organization Study</h4>

                    <div className='row col-md-12 mt-2'>
                        <div className='col-md-3'>
                            <FormControl fullWidth >
                                <InputLabel style={{ fontSize: 15, color: '#169a8f' }} id="demo-simple-select-label">Phase</InputLabel>
                                <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    value={phase}
                                    label="Designation"
                                    onChange={e => setPhase(e.target.value)}
                                    style={{ fontSize: 15, minWidth: '120px' }}
                                    MenuProps={{ // Style for menu options
                                        PaperProps: {
                                            style: {
                                                maxHeight: 300,
                                                width: '20ch',
                                            },
                                        },
                                    }}
                                >
                                    <MenuItem value={"Phase I"} style={{ fontSize: 15 }}>Phase I</MenuItem>
                                    <MenuItem value={"Phase II"} style={{ fontSize: 15 }}>Phase II</MenuItem>
                                    <MenuItem value={"Phase III"} style={{ fontSize: 15 }}>Phase III</MenuItem>
                                    <MenuItem value={"Phase IV"} style={{ fontSize: 15 }}>Phase IV</MenuItem>
                                </Select>
                            </FormControl>
                        </div>
                        <div className='col-md-3'>
                            {/* how to get therpatic areas value use a state and console it's value */}
                            <Autocomplete
                                id="therapeutic-areas"
                                options={therapeuticAreasArr}
                                getOptionLabel={(option) => option.title}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label="Therapeutic Areas"
                                        fullWidth
                                        // value={therapeuticAreas}
                                        InputLabelProps={{
                                            style: { fontSize: 15, color: '#169a8f' } // Style for InputLabel
                                        }}
                                        inputProps={{
                                            ...params.inputProps,
                                            style: { fontSize: 15 } // Style for input text
                                        }}
                                        onBlur={e => setTherapeuticAreas(e.target.value)}
                                    />
                                )}
                                style={{ fontSize: 15 }}
                                MenuProps={{
                                    anchorOrigin: {
                                        vertical: 'bottom', // Ensure menu opens downward
                                        horizontal: 'left',
                                    },
                                    transformOrigin: {
                                        vertical: 'top',
                                        horizontal: 'left',
                                    },
                                    getContentAnchorEl: null, // Prevent menu from being anchored to the input
                                    PaperProps: {
                                        style: {
                                            maxHeight: 300,
                                            width: '20ch',
                                        },
                                    },
                                }}
                            />

                        </div>
                        <div className='col-md-3'>
                            <TextField
                                InputLabelProps={{ style: { fontSize: 18, color: '#169a8f' } }}
                                InputProps={{ style: { fontSize: 18 } }}
                                id="outlined-basic"
                                label="Indication"
                                variant="outlined"
                                onChange={e => setIndication(e.target.value)}
                                value={indication}
                            />
                        </div>
                        <div className='col-md-3'>
                            <TextField
                                inputProps={{
                                    type: 'number',
                                    pattern: '[0-9]{1,20}', // Allow only numbers and limit to 20 characters
                                    title: 'Please enter up to 20 numbers.' // Error message to be shown on validation failure
                                }}
                                InputLabelProps={{ style: { fontSize: 18, color: '#169a8f' } }}
                                InputProps={{ style: { fontSize: 18 } }}
                                id="outlined-basic"
                                label="Enrollement Goal"
                                variant="outlined"
                                onChange={e => setEnrollementGoal(e.target.value)}
                                value={enrollementGoal}
                            />
                        </div>
                        <div className='col-md-3 mt-4'>
                            <TextField
                                InputLabelProps={{ style: { fontSize: 18, color: '#169a8f' } }}
                                InputProps={{ style: { fontSize: 18 ,} }}
                                value={enrollment}
                                onChange={e => {
                                    handleInputChange(e)
                                    setEnrollementMet(e.target.value)
                                }}
                                onBlur={handleInputBlur}
                                onFocus={handleInputFocus}
                                error={error}
                                helperText={error ? 'Please enter a valid enrollment with percentage sign (%)' : ''}
                                id="outlined-basic"
                                label="Enrollment Met"
                                variant="outlined"
                                placeholder="e.g., 50%" // Placeholder to guide the user
                            />
                        </div>
                    </div>
                    <div className='col-md-2 mt-4 saveBtnStyle'>
                        <button className="cta" onClick={handleSubmit}>
                            <span>Save</span>
                            <svg width="15px" height="10px" viewBox="0 0 13 10">
                                <path d="M1,5 L11,5"></path>
                                <polyline points="8 1 12 5 8 9"></polyline>
                            </svg>
                        </button>
                    </div>
                </Box>
            </Modal>
            <div className='mt-4'>
                <TableContainer component={Paper}>
                    <Table sx={{ minWidth: 700 }} aria-label="customized table">
                        <TableHead>
                            <TableRow>
                                <StyledTableCell align="right">Phase</StyledTableCell>
                                <StyledTableCell >Therapeutic Areas</StyledTableCell>
                                <StyledTableCell align="right">Indication</StyledTableCell>
                                <StyledTableCell align="right">Enrollement Goal</StyledTableCell>
                                <StyledTableCell align="right">Enrollement Met</StyledTableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {allStudies.length !== 0 ? allStudies.map((v) => (
                                <StyledTableRow key={v._id}>
                                    <StyledTableCell component="th" scope="row">
                                        {v.phase}
                                    </StyledTableCell>
                                    <StyledTableCell align="right">{v.therapeuticAreas}</StyledTableCell>
                                    <StyledTableCell align="right">{v.indication}</StyledTableCell>
                                    <StyledTableCell align="right">{v.enrollementGoal}</StyledTableCell>
                                    <StyledTableCell align="right">{v.enrollementMet}</StyledTableCell>
                                </StyledTableRow>
                            )) :
                                <StyledTableRow>
                                    <StyledTableCell component="th" scope="row">
                                        No Record Found
                                    </StyledTableCell>
                                </StyledTableRow>
                            }
                        </TableBody>
                    </Table>
                </TableContainer>
            </div>
        </Box>
    );
};

export default StaffStudy;
